import React, { Component } from 'react'

export class Loading extends Component {
  render() {
    return (
      <div>Loading</div>
    )
  }
}

export default Loading